<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form class="form-horizontal">
          <div class="box box-info" >
        <div class="p-toolbar p-component mb-4">
              <Button  class="p-button p-component p-button-success addNewBtn btn-btm-0" label="NEW"  @click.prevent="openAddDialog" icon="pi pi-plus"/>
            </div>
          </div>
          <Dialog header="USER" :visible.sync="showDialog"
           :style="{width: '50vw'}" :modal="true" :closable="false" :contentStyle="{'overflow': 'visible'}">
           <div class="p-fluid p-formgrid p-grid">
             <div class="p-field p-col-12 p-md-6">
              <label for="accountHead" >Name</label>
                <InputText v-model.trim="name" id="accountHead"/>
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="!this.editing">
              <label for="username">Username<span style="color:red">*</span></label>
              <InputText v-model.trim="userName" id="username"/>
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="!this.editing">
              <label for="password" >Password<span style="color:red">*</span></label>
              <Password type="password" v-model.trim="password" id="password"/>
            </div>
             <!-- <a><i class="pi pi-eye" style="margin-top: 2em;" aria-hidden="true"  @click="showPass"></i></a> -->
              <div class="p-field p-col-12 p-md-6" v-if="!this.editing">
                <label for="rePassword" >Re-password<span style="color:red">*</span></label>
                <Password type="rePassword" v-model.trim="rePassword" id="rePassword"/>
            </div>
             <!-- <a><i class="pi pi-eye" style="margin-top: 2em;" aria-hidden="true"  @click="showConfirmPass"></i></a> -->
            <div class="p-field p-col-12 p-md-6">
              <label for="role">Role<span style="color:red">*</span></label>
              <Dropdown
                v-model="roleId" :filter=true
                :options="roleLists"
                id=role
                optionLabel="name"
                placeholder="Select Role"
                :showClear="true"
              />
              <!-- Horizontal layout for checkboxes -->
              <div class="p-grid" style="margin-top: 1rem;">
                <div class="p-col-6">
                  <div class="flex flex-col gap-2">
                    <label>Two-Factor Authentication</label>
                    <div class="flex align-items-center">
                      <Checkbox v-model="enable2FA" :binary="true" :disabled="true"/>
                      <label class="ml-2">
                        {{ enable2FA ? 'Enabled' : 'Disabled' }}
                        <span :style="{ color: enable2FA ? 'green' : 'red' }">
                          ({{ enable2FA ? 'Active' : 'Inactive' }})
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="flex flex-col gap-2">
                    <label>Enable Login Time</label>
                    <div class="flex align-items-center">
                      <Checkbox v-model="enableLoginTime" :binary="true"/>
                      <label class="ml-2">
                        {{ enableLoginTime ? 'Enabled' : 'Disabled' }}
                        <span :style="{ color: enableLoginTime ? 'green' : 'red' }">
                          ({{ enableLoginTime ? 'Active' : 'Inactive' }})
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="openingBalance">Status</label>
                <div class="p-field p-col-12 p-md-6">
                  <RadioButton id="active" name="ACTIVE" value="ACTIVE" v-model="status" />
                  <label for="active">Active</label>
                  <RadioButton id="inactive" name="INACTIVE" value="INACTIVE" v-model="status" />
                  <label for="inactive">Inactive</label>
                </div>
              </div>
      <!-- <div class="col-md-4">
               <label for="warehouse">Store</label>
                <Dropdown
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                 <wearhouseDialog style="float: left;margin: -10% 0% 0% 96%;" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
              </div> -->
              <div class="p-field p-col-12 p-md-6">
              <label for="role">Email<span style="color:red"></span></label>
              <InputText v-model.trim="email" id="accountHead"/>
            </div>

              <div class="p-field p-col-12 p-md-6">
              <label for="role">Store<span style="color:red"></span></label>
              <Dropdown
                v-model="warehouseId" :filter=true
                :options="warehouseLists"
                id=role
                optionLabel="name"
                placeholder="Select Store"
                :showClear="true"
              />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="role">Counter<span style="color:red"></span></label>
              <Dropdown
                v-model="counterId" :filter=true
                :options="counterLists"
                id=role
                optionLabel="name"
                placeholder="Select Counter"
                :showClear="true"
              />
             <!-- {{warehouseId}} -->
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="crmCustomerWise">Customer Category</label>
              <MultiSelect
                v-model="crmCustomerWises"
                :options="crmCustomerOptions"
                optionLabel="label"
                placeholder="Select Categories"
                display="chip"
                id="crmCustomerWise"
              />
            </div>
          </div>
           <template #footer>
            <Button class="p-button-raised"
            @click.prevent="addUser"
             :label="!editing?'Add':'Update'"/>
             <Button class="p-button-raised p-button-info"
            @click.prevent="addAndNewUser" v-if="!editing" label="Add & New"/>
            <Button label="Cancel" @click.prevent="cancel" class="p-button-raised p-button-danger"/>
          </template>
          </Dialog>
        </form>
        <userList @delete-user="deleteUser"  @edit-user="updateUser"/>
      </div>
  </section>
</template>
<script>
import userList from './userList.vue'
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Checkbox from 'primevue/checkbox'
import MultiSelect from 'primevue/multiselect'
export default {
  name: 'userCreate',
  data() {
    return {
      name: '',
      roleId: '',
      warehouseId: null,
      email: '',
      counterId: null,
      userName: '',
      editing: false,
      password: '',
      rePassword: '',
      message: '',
      crmCustomerWises: [],
      crmCustomerOptions: [
        {label: 'Hospital/pharmacy', value: 'Hospital/pharmacy'},
        {label: 'Restaurant', value: 'Restaurant'},
        {label: 'New Restaurant', value: 'New Restaurant'},
        {label: 'Oil And Gas', value: 'Oil And Gas'},
        {label: 'Mart', value: 'Mart'},
        {label: 'Khanepani', value: 'Khanepani'},
        {label: 'Suppliers', value: 'Suppliers'},
        {label: 'Cinemas', value: 'Cinemas'},
        {label: 'Other', value: 'Other'}
      ],
      enable2FA: false,
      enableLoginTime: false,
      show: false,
      messageType: '',
      showDialog: false,
      loading: false,
      status: 'ACTIVE',
      userId: null
    }
  },
  computed: {
    roleLists() {
      return this.$store.state.users.roleLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseLists
    },
    counterLists() {
      return this.$store.state.pos.countersList
    }
  },
  mounted() {
    this.roleList()
    this.warehouseList()
    this.counterList()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseList')
    },
    async counterList() {
      await this.$store.dispatch('loadCountersList')
    },
    async addUser() {
      let response = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (!this.editing) {
        if (this.password !== this.rePassword) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Password did not match!', life: 10000})
          return
        }
      }
      if (this.warehouseId === undefined || this.warehouseId === null) {
        this.warehouseId = null
      }
      if (this.roleId === undefined || this.roleId === null) {
        this.roleId = null
      }
      let user = {
        name: this.name,
        username: this.userName,
        role: this.roleId,
        password: this.password,
        status: this.status,
        userId: this.userId,
        warehouseId: this.warehouseId,
        email: this.email,
        enable2FA: this.enable2FA,
        enableLoginTime: this.enableLoginTime,
        counterId: this.counterId,
        crmCustomerWises: this.crmCustomerWises.map(item => item.value)
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createUser', user)
        console.log(response)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateUser', user)
        this.loading = false
      }
      this.responseMessage(response)
      this.showDialog = false
    },
    async addAndNewUser() {
      let response = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (!this.editing) {
        if (this.password.trim !== this.rePassword.trim) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Password did not match!', life: 10000})
          return
        }
      }
      if (this.warehouseId === undefined || this.warehouseId === null) {
        this.warehouseId = null
      }
      if (this.roleId === undefined || this.roleId === null) {
        this.roleId = null
      }
      let user = {
        name: this.name,
        username: this.userName,
        role: this.roleId,
        password: this.password,
        status: this.status,
        userId: this.userId,
        warehouseId: this.warehouseId,
        email: this.email,
        enable2FA: this.enable2FA,
        enableLoginTime: this.enableLoginTime,
        counterId: this.counterId,
        crmCustomerWises: this.crmCustomerWises.map(item => item.value)
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createUser', user)
      this.loading = false
      this.responseMessage(response)
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.cancel()
      } else if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!', life: 10000})
      }
    },
    async roleList() {
      await this.$store.dispatch('loadRole')
    },
    deleteUser(data) {
      this.$toast.add({severity: data.messageType, summary: '', detail: data.message, life: 10000})
    },
    updateUser(data) {
      this.name = data.name
      this.userName = data.username
      this.roleId = data.role
      this.editing = !this.editing
      this.showDialog = !this.showDialog
      this.status = data.status
      this.userId = data.id
      this.warehouseId = data.warehouseId
      this.enable2FA = data.enable2FA
      this.enableLoginTime = data.enableLoginTime
      this.email = data.email
      if (data.crmCustomerWises && Array.isArray(data.crmCustomerWises)) {
        this.crmCustomerWises = data.crmCustomerWises.map(item => {
          return this.crmCustomerOptions.find(option => option.value === item) || { label: item, value: item }
        })
      } else {
        this.crmCustomerWises = []
      }
    },
    showPass() {
      var x = document.getElementById('password')
      if (x.type === 'password') {
        x.type = 'text'
      } else {
        x.type = 'password'
      }
    },
    showConfirmPass() {
      var x = document.getElementById('rePassword')
      if (x.type === 'password') {
        x.type = 'text'
      } else {
        x.type = 'password'
      }
    },
    openAddDialog() {
      this.showDialog = !this.showDialog
    },
    cancel(data) {
      this.name = ''
      this.userName = ''
      this.roleId = ''
      this.password = ''
      this.rePassword = ''
      this.enable2FA = ''
      this.enableLoginTime = ''
      this.email = ''
      this.editing = false
      this.showDialog = false
      this.warehouseId = null
      this.counterId = null
      this.crmCustomerWises = []
    },
    resetResponse() {
      this.response = ''
      this.roleId = ''
    }
  },
  components: {
    userList,
    Dropdown,
    Dialog,
    RadioButton,
    InputText,
    Button,
    Password,
    Checkbox,
    MultiSelect
    // Toast
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
.p-checkbox-box.p-highlight {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.status-indicator {
  margin-left: 0.5rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// user.vue?34addf4e